"use strict";
/**
 * @deprecated Loxo-specific types are deprecated. Use Merge types from './merge' instead.
 *
 * These types are kept for backwards compatibility during migration.
 * New integrations should use the Merge Unified API types:
 * - MergeCandidate instead of LoxoPerson
 * - MergeIntegration instead of LoxoIntegration
 * - See './merge' for all available Merge types
 *
 * Migration guide:
 * 1. Replace LoxoPerson with MergeCandidate
 * 2. Replace LoxoIntegration with MergeIntegration
 * 3. Use scoutCandidateToMergeCandidate() for conversion
 */
Object.defineProperty(exports, "__esModule", { value: true });
